import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { ShopCartInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-shop-panier-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: ShopCartInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as ShopCartInitData;
    } catch (error) {
        window.console?.error?.('[gas-shop-cart] init JSON invalide', error);
        initData = {} as ShopCartInitData;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasToastProvider>
                <GasConfirmProvider>
                    <App initData={initData} />
                </GasConfirmProvider>
            </GasToastProvider>
        </React.StrictMode>,
    );
}
